module.exports = __webpack_public_path__ + "media/images/emblems/Schoneng-632d38df090f122e055ecbb54682fdb1.png";